<template>
  <div class="Report">
    <div class="title">
      <div class="title">
        <h2 class="light">
          Reports
        </h2>
      </div>
      <Tabs
        :options="reports"
        v-model="tab" />
    </div>
    <!-- title -->
    <div
      class="container"
      v-if="tab === 'sales'">
      <div
        v-for="year of salesYears"
        :key="year">
        <h4>{{ year }}</h4>
        <table class="panel">
          <thead>
            <tr>
              <td>Name</td>
              <td>Month</td>
              <td>Due</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            <SalesReportListItem
              v-for="report in salesReportsListByYear[year]"
              :key="report.id"
              :report="report" />
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="container"
      v-if="tab === 'activity'">
      <div
        v-for="year of activityYears"
        :key="year">
        <h4>{{ year }}</h4>
        <table class="panel">
          <thead>
            <tr>
              <td>Name</td>
              <td>Month</td>
              <td>Due</td>
              <td>Status</td>
              <td />
            </tr>
          </thead>
          <tbody>
            <ActivityReportListItem
              v-for="report in activityReportsListByYear[year]"
              :key="report.id"
              :report="report" />
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- Report -->
</template>

<script>
import gql from "graphql-tag";
import Tabs from "@/components/Tabs";
import SalesReportListItem from "@/components/SalesReportListItem";
import ActivityReportListItem from "@/components/ActivityReportListItem";
import groupBy from "lodash/groupBy";
import moment from "moment";

export default {
  components: { SalesReportListItem, ActivityReportListItem, Tabs },
  props: {
    show: {
      type: String,
      default: "sales",
    },
  },
  data: function () {
    return {
      reports: [
        { name: "Sales", value: "sales" },
        { name: "Activity", value: "activity" },
      ],
      tab: String(this.show),
    };
  },

  computed: {
    ptId() {
      return this.$store.getters["profile"].id;
    },

    salesReportsListByYear() {
      return groupBy(this.salesReportsList, (report) =>
        moment(report.periodStart).year()
      );
    },

    salesYears() {
      return Object.keys(this.salesReportsListByYear)
        .sort(reverse);
    },

    activityReportsListByYear() {
      return groupBy(this.activityReportsList, (report) =>
        moment(report.periodStart).year()
      );
    },

    activityYears() {
      return Object.keys(this.activityReportsListByYear)
        .sort(reverse);
    }
  },

  methods: {
    handleActivityReportUpdated() {
      this.$apollo.queries.activityReportsList.refetch();
    },

    handleSalesReportUpdated() {
      this.$apollo.queries.salesReportsList.refetch();
    },
  },
  apollo: {
    activityReportsList: {
      fetchPolicy: "no-cache",
      query: gql`
        query ActivityReportsQuery($ptId: UUID!) {
          activityReportsList(orderBy: PERIOD_START_DESC, condition: {ptId: $ptId}) {
            createdAt
            id
            periodEnd
            periodStart
            status
          }
        }
      `,
      variables() {
        return {
          ptId: this.ptId,
        }
      },
    },

    salesReportsList: {
      fetchPolicy: "no-cache",
      query: gql`
        query SalesReportsQuery($ptId: UUID!) {
          salesReportsList(orderBy: PERIOD_START_DESC, condition: {ptId: $ptId}) {
            id
            periodEnd
            periodStart
            status
          }
        }
      `,
      variables() {
        return {
          ptId: this.ptId,
        }
      },
    },
  },
};

function reverse(a, b) {
  return b-a;
}
</script>

<style lang="scss" scoped>
.Report {
  .title {
    margin-bottom: 1em;
  }
  .container {
    padding: 1em;
  }

  table {
    &.panel {
      padding: 0 !important;
    }
  }
  h4 {
    padding-bottom: 0.5em;
    opacity: 0.5;
    padding-left: 1px;
  }
}
</style>
